/* eslint-disable no-unreachable */
/* eslint-disable no-useless-return */
/* eslint-disable default-param-last */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-else-return */
import { CloseCircleFilled, EditFilled, UndoOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DatePicker, Input, Select, Tooltip, message } from "antd";
import dayjs from "dayjs";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { UserContext } from "../../../../amplify/authenticator-provider";
import {
  CREATE_APPOINTMENT,
  DELETE_APPOINTMENT,
  UPDATE_APPOINTMENT,
} from "../../../../graphql/mutation";
import {
  GET_COMPANY_WORK_HOURS,
  GET_LEAD_INFO_APPOINTMENT,
  GET_LEAD_LIST_ACTIVITY_CENTER,
  GET_LOCATIONS,
} from "../../../../graphql/query";
import useFetchUsers, { USER_QUERIES } from "../../../../hooks/useFetchUsers";
import useLang from "../../../../hooks/useLang";
import useCrm from "../../../../hooks/useCrm";
import RedirectIcon from "../../../../icons/js/RedirectIcon";
import {
  AccessPermissionAction,
  CREATED_BY_USER_TYPE_LEAD,
  TENTATIVE_TIME_VALUE,
  VEHICLE_INTERESTS_TYPE,
} from "../../../../library/constants";
import {
  checkAccessPermission,
  closeDialog,
  getLocationObj,
  openDialog,
} from "../../../../library/helpers";
import { convertUtcToLocal } from "../../../../library/utils";
import useLeadRedirection, { REDIRECTION_TYPES } from "../../../../hooks/useLeadRedirection";
import AntdIconV4 from "../../../../utils/antdIcon";
import { DATE_TIME_FORMATS, toUTCDateTime } from "../../../../utils/dateTimes";
import {
  buildAppointmentStartDate,
  calculateWorkingHoursWindow,
} from "../../../../helpers/appointmentHelpers";
import CustomAlert from "../../../commonComponents/alert";
import CustomButton from "../../../commonComponents/button";
import CustomCheckbox from "../../../commonComponents/checkbox";
import CustomTimePicker from "../../../commonComponents/customTimePicker";
import UserSelector from "../../../commonComponents/userSelector";
import { handleOpportunityDilaog } from "../opporotunityLayer/opportuityWarning";
import TimezoneSelect from "../../../commonComponents/TimezoneSelect";
import {
  getOpportunityDisplayName,
  prepareOpportunityList,
  getDefaultOpportunity,
} from "../../../../helpers/opportunityHelper";
import {
  getRootOppTypeId,
  getUserAllowedRootOppTypeIds,
  isUserUnscoped,
} from "../../../../library/oppTypeScoping";

const { TextArea } = Input;

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone"); // dependent on utc plugin

dayjs.extend(utc);
dayjs.extend(timezone);

const AppointmentForm = props => {
  const {
    lead: selectedLead = null,
    showLeadChanger = false,
    appointment = null,
    setAppointmentModelVisible,
    defaultDate = dayjs().local(),
    redirect = null,
    activeAppointments = [],
    leadOpportunityId,
    leadOpportunities = [],
    onClose,
    eventId = false,
    allowLeadChange = true,
    mode = "EDIT",
    refreshLeadListData = () => {},
    refetchLeads = () => {},
    isFromCard = false,
    refetchAppointmentList = () => {},
    // Active root opp_type tab — when set, filters the opp dropdown
    // to opps under this root AND defaults the selected opp to a
    // matching one.
    selectedOppTypeId = null,
  } = props;

  const { user, setrefetchAppointments, refetchAppointments } = useContext(UserContext);
  const { redirectToLead } = useLeadRedirection();
  const [virtualObj, setvirtualObj] = useState({
    virtual: false,
    videoCallIntegrationType: null,
  });
  const [lang] = useLang();
  const { getOpprDetails } = useCrm();
  const [lead, setlead] = useState({ ...selectedLead });
  const [leadSearch, setleadSearch] = useState("");
  const [isFormChanged, setisFormChanged] = useState(mode === "ADD");
  const [leadList, setleadList] = useState([]);
  const [isAppoinmentConfirm, setIsAppoinmentCofirm] = useState(appointment?.isConfirmed || false);
  const [isChangedByUser, setIsChangedByUser] = useState(appointment?.isConfirmed || false);
  const [dropdownStatus, setDropdownStatus] = useState("");
  const [statusEditMode, setstatusEditMode] = useState(false);
  const [statusDropdownList, setStatusDropdownList] = useState([
    { key: "CANCELLED", value: "CANCELLED", label: "Cancel" },
  ]);
  const [userLocationsId, setUserLocationsId] = useState([]);
  // opportunity status list and selectedStatus
  const [title, setTitle] = useState(user ? `Appointment at ${user?.company?.name}` : "");
  const [users, setUsers] = useState([
    {
      id: appointment?.user?.id ? appointment?.user?.id : user?.id,
      name: `${appointment?.user?.fullName ? appointment?.user?.fullName : user?.fullName} (${
        appointment?.user?.companyRole?.name
          ? appointment?.user?.companyRole?.name
          : user?.companyRole?.name
      })`,
    },
  ]);
  const [assignedUserId, setAssignedUserId] = useState(user?.id || "");
  const [openAppointmentConfirm, setOpenAppointmentConfirm] = useState(false);
  const [whileCreateNewOppr, setWhileCreateNewoppr] = useState([]);
  const [opportunityInfo, setOpportunityInfo] = useState({});
  const [opportunityWarningDialog, setOpportunityWarningDialog] = useState(false);
  const [leadInfo, setLeadInfo] = useState({});
  const [error, setError] = useState("");
  const [appointmentDate, setAppointmentDate] = useState(defaultDate);
  const [appointmentTime, setAppointmentTime] = useState(
    !isEmpty(appointment) ? null : dayjs().add(1, "hours").format("h:mm A")
  );

  const [note, setNote] = useState("");
  const [timezone, setTimezone] = useState(null);
  const [vehicle, setVehicle] = useState();
  const [vehiclesOfInterests, setVehiclesOfInterests] = useState([]);
  // Initial leadOpportunity — prefer the appointment's existing opp
  // (EDIT mode), else the most-recent opp under the active tab's root
  // (ADD mode with an active tab), else fall back to the first opp.
  const tabMatchingOpp = (() => {
    if (!selectedOppTypeId || !Array.isArray(leadOpportunities)) return null;
    const matches = leadOpportunities.filter(
      o => Number(getRootOppTypeId(o?.opportunityType)) === Number(selectedOppTypeId)
    );
    if (matches.length === 0) return null;
    return [...matches].sort((a, b) => {
      const ta = new Date(a?.updatedDate || a?.createdDate || 0).getTime();
      const tb = new Date(b?.updatedDate || b?.createdDate || 0).getTime();
      return tb - ta;
    })[0];
  })();
  const [leadOpportunity, setLeadOpportunity] = useState(
    String(
      // EDIT mode: pin to the appointment's own opp.
      appointment?.leadOpportunityId ||
        appointment?.leadOpportunity?.id ||
        // ADD mode: prefer the most-recent opp under the active tab.
        tabMatchingOpp?.id ||
        // Final fallback: first opp by lead-opp id. NEVER fall back to
        // dsOpportunityEvents[].dsEventId / sfLeadOpportunities[].sfOpportunityId
        // — those are CRM EVENT ids, not lead_opportunity.id, so the
        // Select.Option list (keyed by opp id) has nothing to match and
        // antd ends up rendering the bare event-id (e.g. "3201359") in
        // place of the opp name.
        leadOpportunities[0]?.id ||
        ""
    )
  );
  useEffect(() => {
    if (!appointment) {
      setAppointmentDate(dayjs(defaultDate.toISOString()));
    }
  }, [defaultDate]);
  const hadnleAppointmentDialog = () => {
    openDialog("appointmentConfirm", {
      dialogHeader: lang.appointmentConfirmation,
      handleCancelBtn: () => {
        closeDialog("appointmentConfirm");
        setIsAppoinmentCofirm(false);
      },
      handleConfirm: () => closeDialog("appointmentConfirm"),
    });
    // setOpenAppointmentConfirm(!openAppointmentConfirm);
  };

  const { data: respLocation } = useQuery(GET_LOCATIONS, {
    skip: !user?.company?.id,
    variables: { companyId: user?.company?.id || 0 },
    onCompleted: resp => {
      try {
        const location = (resp?.getLocations || []).find(
          el => el?.id && +el.id === +sessionStorage.getItem("currentLocationId")
        );
        if (location?.title) {
          setTitle(
            `${lang?.appointment || "Appointment"} ${lang?.at?.toLowerCase() || "at"} ${
              location.title
            }`
          );
        }
      } catch (error) {
        console.error("Error processing location data:", error);
      }
    },
    onError: error => {
      console.error("Error fetching locations:", error);
    },
  });

  const { data: leadData } = useQuery(GET_LEAD_INFO_APPOINTMENT, {
    skip: !selectedLead?.id,
    variables: { leadId: +(selectedLead?.id || 0) },
    onCompleted: res => {
      try {
        setLeadInfo(res?.lead || {});
      } catch (error) {
        console.error("Error processing lead info:", error);
      }
    },
    onError: error => {
      console.error("Error fetching lead info:", error);
    },
  });

  const { data: respWorkHrs, loading: workHoursLoading } = useQuery(GET_COMPANY_WORK_HOURS, {
    variables: {
      companyId: user?.company?.id || 0,
      locationId: parseInt(sessionStorage.getItem("currentLocationId") || 0),
    },
    fetchPolicy: "network-only",
  });
  const [createAppointment, { loading }] = useMutation(CREATE_APPOINTMENT);
  const [updateAppointment, { loading: updateLoading }] = useMutation(UPDATE_APPOINTMENT);
  const [deleteAppointment, { loading: deleteLoading }] = useMutation(DELETE_APPOINTMENT);

  const worksHours = respWorkHrs?.getCompanyWorkingHours || [];

  const [assignedUserData, setAssignedUserData] = useState(null);

  // Fetch users using useFetchUsers hook with GET_ALL_USERS_APPOINTMENT_FORM query
  const handleUsersFetchComplete = res => {
    try {
      const users = res?.getUsers?.data || [];
      const list = (users || [])
        .filter(el => el && !el.isDisabled)
        .map(el => ({
          id: el?.id,
          name: `${el?.fullName || "Unknown"} (${
            el?.companyRole?.name || user?.companyRole?.name || "N/A"
          }) `,
        }));
      setUsers(list);

      const appointmentUserId = appointment?.userId || appointment?.user?.id;
      const findIndex = list.findIndex(el => el?.id && +el.id === +appointmentUserId);
      if (findIndex > -1) {
        setAssignedUserId(String(list[findIndex]?.id));
      }

      // Store the assigned user full data for UserSelector
      const targetUserId = appointmentUserId || assignedUserId;
      const assignedUser = users.find(u => u?.id && +u.id === +targetUserId);
      if (assignedUser) {
        setAssignedUserData(assignedUser);
      }
    } catch (error) {
      console.error("Error processing users data:", error);
    }
  };

  const { loading: fetchLoading } = useFetchUsers(
    null,
    handleUsersFetchComplete,
    !user?.company?.id,
    {
      isGlobalLeadOwner: true,
      query: USER_QUERIES.USER_APPOINTMENT,
    }
  );

  const [getLeads, { data: leads, loading: leadsLoader }] = useLazyQuery(
    GET_LEAD_LIST_ACTIVITY_CENTER,
    {
      fetchPolicy: "network-only",
      variables: {
        search: leadSearch,
        page: 1,
        pageSize: 20,
      },
    }
  );
  useEffect(() => {
    if (!lead && !appointment) return;

    // Build vehicle list from all available sources (lead prop + appointment.lead), deduped
    const allVehicles = [
      ...(lead?.leadVehicleInventory || []),
      ...(lead?.vehicleOfInterest || []),
      ...(appointment?.lead?.leadVehicleInventory || []),
      ...(appointment?.lead?.vehicleOfInterest || []),
    ];
    const tempvehiclesOfInterests = [];
    allVehicles.forEach(el => {
      if (tempvehiclesOfInterests.findIndex(e => +e.id === +el.id) === -1) {
        tempvehiclesOfInterests.push(el);
      }
    });
    setVehiclesOfInterests(tempvehiclesOfInterests);

    // In edit mode, use the appointment's discussedVoiId; otherwise default to first
    const vid = String(appointment?.discussedVoiId || "");
    if (!isEmpty(vid) && tempvehiclesOfInterests.findIndex(el => String(el.id) === vid) > -1) {
      setVehicle(vid);
    } else {
      setVehicle(tempvehiclesOfInterests.length > 0 ? String(tempvehiclesOfInterests[0].id) : "");
    }
  }, [lead, appointment]);
  const getLocation = () => {
    try {
      if (!user?.locations || !Array.isArray(user.locations)) {
        return null;
      }
      return user.locations.find(
        item => item?.location?.id === sessionStorage.getItem("currentLocationId")
      );
    } catch (error) {
      console.error("Error getting location:", error);
      return null;
    }
  };
  const locationObj = useMemo(getLocation, [user]);

  useEffect(() => {
    try {
      const currentLocationId = sessionStorage.getItem("currentLocationId") || "";
      const isMultipleLocations = currentLocationId.includes(",");
      const browserTimezone = dayjs.tz.guess();

      if (isMultipleLocations) {
        setTimezone(browserTimezone);
      } else {
        const locationTimezone = locationObj?.location?.timezone;
        setTimezone(locationTimezone || browserTimezone);
      }
    } catch (error) {
      console.error("Error setting timezone:", error);
      setTimezone(dayjs.tz.guess()); // Fallback to browser timezone
    }
  }, [locationObj]);

  useEffect(() => {
    if (!isEmpty(selectedLead)) {
      setlead({ ...selectedLead });
    } else {
      getLeads();
    }
  }, [selectedLead]);
  useEffect(() => {
    if (!isEmpty(leads?.getLeads?.data) && isArray(leads?.getLeads?.data)) {
      setleadList(leads.getLeads.data);
    }
  }, [leads?.getLeads?.data]);
  useEffect(() => {
    if (appointment?.appointmentStatus) {
      setDropdownStatus(appointment?.appointmentStatus);
    }
  }, [appointment?.appointmentStatus]);
  useEffect(() => {
    if (lead?.activeAppointment?.appointmentStatus && isFromCard) {
      setDropdownStatus(lead?.activeAppointment?.appointmentStatus);
    }
  }, [lead?.activeAppointment?.appointmentStatus]);
  useEffect(() => {
    if (appointment && !isEmpty(appointment) && mode === "EDIT") {
      setAppointmentDate(
        dayjs.utc(appointment?.startDatetime).tz(appointment?.timezone || dayjs.tz.guess()) ||
          dayjs()
      );
      if (
        appointment?.extraData?.is_tentative_appointment_time ||
        selectedLead?.activeAppointment?.extraData?.is_tentative_appointment_time
      ) {
        setAppointmentTime(TENTATIVE_TIME_VALUE);
      } else {
        setAppointmentTime(
          dayjs
            ?.utc(appointment?.startDatetime)
            ?.tz(appointment?.timezone || dayjs.tz.guess())
            ?.format("h:mm A") || dayjs()?.add(1, "hours")?.format("h:mm A")
        );
      }
      setNote(appointment?.description || "");
      setTitle(appointment?.summary || "");
      setTimezone(appointment?.timezone || dayjs.tz.guess());

      const uid = String(appointment?.userId || appointment?.user?.id || "");
      if (!isEmpty(uid)) {
        setAssignedUserId(uid);
      }
    }
  }, [appointment]);

  const handleDeleteAppointment = e => {
    if (e && !isUndefined(appointment?.id)) {
      openDialog("confirmDialog", {
        label: lang.doYouWantToContinue,
        content: lang.clickOnOK,
        okBtnType: "danger",
        confirmBtnText: lang.yes,
        isOKGhost: true,
        handleConfirm: async () => {
          try {
            const resp = await deleteAppointment({
              variables: {
                appointmentId: appointment?.id,
              },
            });
            if (resp?.data?.deleteAppointment?.statusCode === 200) {
              message.success(resp?.data?.deleteAppointment?.message);
              setAppointmentModelVisible(true);
              // DELETE_APPOINTMENT only returns statusCode/message (no appointment).
              // Synthesize a cancelled-state appointment from the existing one so the
              // lead card / profile widget reflect the change immediately. The next
              // natural list refetch will reconcile if the backend hard-deleted it.
              refreshLeadListData({ ...appointment, appointmentStatus: "CANCELLED" }, lead?.id);
              setrefetchAppointments(!refetchAppointments);
              // refetchAppointmentList();
              onClose();
              closeDialog("confirmDialog");
              if (redirect) {
                redirect(
                  false,
                  false,
                  !window.location.pathname.includes("engagements/appointment"),
                  appointment?.lead?.id || lead?.id,
                  false
                );
              }
              closeDialog("appointmentForm");
            } else {
              message.error(resp?.data?.deleteAppointment?.message);
            }
          } catch (mutationError) {
            const error = JSON.parse(JSON.stringify(mutationError));
            message.error(error?.graphQLErrors && error?.graphQLErrors[0]?.message);
          }
        },
      });
    }
  };

  const workingTime = useMemo(
    () =>
      calculateWorkingHoursWindow(
        appointmentDate,
        worksHours,
        locationObj?.location?.settings?.APPOINTMENT_CREATE_OFFSET
      ),
    [appointmentDate, worksHours, locationObj]
  );

  const handleOpportunityWarningDialog = (item, crmLink, opprId, opprName, isOpp = false) => {
    try {
      const itemData = Array.isArray(item) && item.length > 0 ? item[0] : {};
      setOpportunityInfo({
        ...itemData,
        opprLink: crmLink,
        opprId: opprId,
        opprName: opprName,
        isOpp: isOpp,
        crmLeadObj: leadInfo?.crmLeadObj,
      });
      setOpportunityWarningDialog(true);
    } catch (error) {
      console.error("Error setting opportunity info:", error);
    }
  };

  const handleOppDialog = () => {};

  const handleSaveAppointment = async (e, isConfirmBtn = false, isAppConfirm = false) => {
    isConfirmBtn && hadnleAppointmentDialog();

    const isTentative = appointmentTime === TENTATIVE_TIME_VALUE;

    // Define newtime outside the block as it's used later
    const newtime = dayjs(appointmentTime, "h:mm A");

    // Validate working hours exist before time validation
    if (!isTentative && workingTime && workingTime.length >= 2) {
      const startTime = dayjs(workingTime[0], "h:mm A");
      const endTime = dayjs(workingTime[1], "h:mm A");

      if (newtime.isBefore(startTime) || newtime.isAfter(endTime)) {
        message.error(lang?.selectTimeFromSlot || "Please select time from available slot");
        return;
      }
    }

    if (appointment?.id) {
      if (appointmentDate.isBefore(dayjs().format("MM/DD/YYYY")) && !dropdownStatus) {
        message.error(lang?.reschedualInPastDate || "Cannot reschedule to past date");
        return;
      }

      if (!isTentative && dayjs().isSame(appointmentDate, "day")) {
        if (newtime.isBefore(dayjs().format()) && !dropdownStatus) {
          message.error(lang?.reschedualInPasTime || "Cannot reschedule to past time");
          return;
        }
      }
    }

    if (isUndefined(leadOpportunity)) {
      handleOppDialog();
      return;
    }

    if (e) {
      if (isEmpty(title)) {
        setError(lang.enterAppointmentTitle);
        return;
      } else if (isEmpty(appointmentDate) || isEmpty(appointmentTime)) {
        setError(lang.enterAppointmentStartDateTime);
        return;
      }
      const startDate = buildAppointmentStartDate(appointmentDate, appointmentTime, isTentative);
      const tz = timezone || dayjs.tz.guess();
      const utcStartDate = toUTCDateTime(startDate, tz);

      if (!isUndefined(appointment?.id)) {
        let variables = {
          appointmentId: appointment?.id,
          userId: assignedUserId,
          summary: title,
          description: note,
          appointmentTimezone: timezone,
          startDate: utcStartDate,
          endDate: utcStartDate,
          leadOpportunityId:
            +appointment?.leadOpportunityId ||
            +appointment?.leadOpportunity?.id ||
            +leadOpportunity,
          isConfirmed: isAppConfirm || isAppoinmentConfirm,
          ...virtualObj,
          zoomObject: {
            topic: title,
            preSchedule: false,
            startTime: dayjs.tz(startDate, tz).toISOString(),
            hostVideo: true,
            participantVideo: true,
            waitingRoom: true,
          },
        };
        if (!isEmpty(vehicle)) {
          variables.discussedVoiId = vehicle;
        }
        if (!isUndefined(e?.status)) {
          variables.status = e.status;
        }
        variables.isTentativeAppointmentTime = isTentative;

        if (
          eventId &&
          appointment?.leadOpportunity?.dsOpportunityEvents?.length > 0 &&
          appointment?.leadOpportunity?.dsOpportunityEvents.findIndex(
            event => event?.dsEventId === eventId
          ) > -1
        ) {
          variables = { ...variables, dsEventId: eventId };
        } else {
          delete variables.eventId;
        }

        try {
          const resp = await updateAppointment({
            variables,
          });

          if (resp?.data?.updateAppointment?.statusCode === 200) {
            message.success(resp?.data?.updateAppointment?.message);
            setrefetchAppointments(!refetchAppointments);
            refreshLeadListData(resp?.data?.updateAppointment?.appointment, lead?.id);
            setAppointmentModelVisible(true);
            // refetchAppointmentList();
            onClose();
            if (showLeadChanger) {
              return;
            }
            // refetchAppointmentList();
            setrefetchAppointments(!refetchAppointments);
            redirect(
              false,
              resp?.data?.updateAppointment?.appointment?.startDatetime,
              !window.location.pathname.includes("appointment"),
              appointment?.lead?.id || lead?.id
            );
          } else {
            message.error(resp?.data?.updateAppointment?.message);
          }
        } catch (mutationError) {
          const error = JSON.parse(JSON.stringify(mutationError));
          message.error(error?.graphQLErrors && error?.graphQLErrors[0]?.message);
        }
      } else {
        let variables = {
          leadId: lead?.id,
          userId: assignedUserId,
          summary: title,
          description: note,
          appointmentTimezone: timezone,
          startDate: utcStartDate,
          endDate: utcStartDate,
          leadOpportunityId: +leadOpportunity || +leadOpportunities[0]?.id,
          isConfirmed: isAppConfirm || isAppoinmentConfirm,
          ...virtualObj,
          zoomObject: {
            topic: title,
            preSchedule: false,
            startTime: dayjs.tz(startDate, tz).toISOString(),
            hostVideo: true,
            participantVideo: true,
            waitingRoom: true,
          },
        };
        if (!isEmpty(vehicle)) {
          variables.discussedVoiId = vehicle;
        }
        variables.isTentativeAppointmentTime = isTentative;

        const filterEvent = (
          lead?.crmLeadObj?.activeLeadOpportunity?.dsOpportunityEvents || []
        ).filter(ev => ev.dsEventId === eventId);

        if (eventId && filterEvent.length > 0) {
          variables = { ...variables, dsEventId: eventId };
        } else {
          delete variables.eventId;
        }

        try {
          const resp = await createAppointment({
            variables,
          });
          if (resp?.data?.createAppointment?.statusCode === 200) {
            message.success(resp?.data?.createAppointment?.message);
            setAppointmentModelVisible(true);
            refetchLeads(resp?.data?.createAppointment?.appointment, lead?.id);
            // refetchAppointmentList();
            setrefetchAppointments(!refetchAppointments);
            onClose();
            if (showLeadChanger) {
              return;
            }
            redirect(
              false,
              resp?.data?.createAppointment?.appointment?.startDatetime,
              true,
              appointment?.lead?.id || lead?.id
            );
          } else {
            message.error(resp?.data?.createAppointment?.message);
          }
        } catch (mutationError) {
          const error = JSON.parse(JSON.stringify(mutationError));
          message.error(error?.graphQLErrors && error?.graphQLErrors[0]?.message);
        }
      }
    }
  };
  const disabledControl = () => {
    return (
      appointment?.appointmentStatus === "CANCELLED" ||
      appointment?.appointmentStatus === "NO_SHOWED" ||
      appointment?.appointmentStatus === "SHOWED" ||
      (sessionStorage.getItem("currentLocationId") || "").includes(",")
    );
  };

  const disableWeekDay = date => {
    const day = dayjs(date).format("dddd");
    const index = worksHours.findIndex(el => el.weekDay === day.toUpperCase() && !el.isWorkingDay);
    return index > -1;
  };

  const onChange = e => {
    if (e) {
      setisFormChanged(true);
      setAppointmentDate(e);
      setIsAppoinmentCofirm(false);
      setIsChangedByUser(false);
      setAppointmentTime(null);
    }
  };
  const onTimeChange = e => {
    if (e === TENTATIVE_TIME_VALUE) {
      setisFormChanged(true);
      setAppointmentTime(e);
      setIsAppoinmentCofirm(false);
      setIsChangedByUser(false);
      return;
    }
    const nowInSelectedTZ = dayjs().tz(timezone);
    const appointmentDateInTZ = appointmentDate.tz(timezone);
    const selectedTimeInTZ = dayjs(
      `${appointmentDate.format("YYYY-MM-DD")} ${e}`,
      "YYYY-MM-DD h:mm A"
    ).tz(timezone);
    if (e) {
      if (appointmentDateInTZ.isSame(nowInSelectedTZ, "day")) {
        if (selectedTimeInTZ.isAfter(nowInSelectedTZ)) {
          setisFormChanged(true);
          setAppointmentTime(e);
        } else {
          message.error(lang.reschedualInPasTime);
        }
      } else {
        setisFormChanged(true);
        setAppointmentTime(e);
      }
    }
    setIsAppoinmentCofirm(false);
    setIsChangedByUser(false);
  };

  const getAppointmentTimes = () => {
    const list = (activeAppointments || []).filter(el => {
      return (
        convertUtcToLocal(el?.startDatetime, "MM/DD/YYYY") ===
        dayjs(appointmentDate).format("MM/DD/YYYY")
      );
    });
    const hours = (list || []).map(el => {
      return convertUtcToLocal(el?.startDatetime, "h:mm A");
    });
    return hours;
  };

  const disabledHours = getAppointmentTimes();

  const isExistingTentative =
    appointment?.extraData?.is_tentative_appointment_time ||
    selectedLead?.activeAppointment?.extraData?.is_tentative_appointment_time;
  const showTentativeOption =
    locationObj?.location?.settings?.ALLOW_TENTATIVE_APPOINTMENT_TIME ||
    isExistingTentative ||
    false;

  const canSchedule = checkAccessPermission(AccessPermissionAction.APPOINTMENT_SCHEDULE);
  const canReSchedule = checkAccessPermission(AccessPermissionAction.APPOINTMENT_UPDATE);
  const canCancel = checkAccessPermission(AccessPermissionAction.APPOINTMENT_CANCEL);

  useEffect(() => {
    // The dropdown options are keyed by the internal opportunity id, so the selected
    // value must also be the internal id. Prefer the appointment's own opportunity
    // (leadOpportunityId, else leadOpportunity.id) before falling back to the list.
    const apptOpprId = appointment?.leadOpportunityId || appointment?.leadOpportunity?.id;
    if (apptOpprId) {
      // Editing an existing appointment — keep its own opportunity.
      setLeadOpportunity(apptOpprId);
    } else {
      // Creating (no appointment id) — default to the most-recent active opportunity
      // (getDefaultOpportunity), from the same list the dropdown options use.
      // When an opp-type tab is active, narrow the candidate pool to opps
      // under that root first — picking from there matches the panel
      // context and prevents the Service-tab user from getting a Sales
      // appointment defaulted in.
      const opportunitiesForDefault = lead?.leadOpportunities?.length
        ? lead.leadOpportunities
        : leadOpportunities;
      let tabScoped = opportunitiesForDefault;
      if (selectedOppTypeId && Array.isArray(opportunitiesForDefault)) {
        const matches = opportunitiesForDefault.filter(
          o => Number(getRootOppTypeId(o?.opportunityType)) === Number(selectedOppTypeId)
        );
        if (matches.length > 0) tabScoped = matches;
      }
      const defaultOpprId = getDefaultOpportunity(tabScoped)?.id;
      // Final fallback is the FIRST opp in the (tab-scoped) list by its
      // internal id. Never fall back to dsEventId / sfOpportunityId —
      // those are CRM event ids that don't match any Select.Option key,
      // so antd would render the raw number (e.g. "3201359") in place
      // of the opp name.
      setLeadOpportunity(defaultOpprId || tabScoped[0]?.id || leadOpportunities[0]?.id);
    }

    if (window.location.pathname.includes("appointment")) {
      if (!leadOpportunity) {
        if (!appointment?.leadOpportunityId) {
          handleOppDialog();
          return;
        }
      }
    } else {
      if (appointment?.leadOpportunityId) {
        return;
      }
      if (leadOpportunities.length === 0) {
        handleOppDialog();
      } else {
        if (leadOpportunities.length > 0) {
          return;
        } else if (isUndefined(leadOpportunityId)) {
          handleOppDialog();
        }
      }
    }
  }, [leadOpportunities.length, leadOpportunityId]);

  const handleLeadOpportunityList = () => {
    const opportunities =
      mode === "EDIT"
        ? appointment?.leadOpportunity
          ? [appointment.leadOpportunity]
          : appointment?.lead?.leadOpportunities
        : lead?.leadOpportunities;

    // Permission + tab-scoped filter (ADD mode only; EDIT preserves the
    // existing single-opp shape). Hides opps under roots the user has no
    // permission for, and narrows further to the active tab's root when
    // a tab is selected so the dropdown matches the panel context.
    let scoped = opportunities;
    if (mode !== "EDIT" && Array.isArray(scoped)) {
      const userAllowed = getUserAllowedRootOppTypeIds(user);
      const unscoped = isUserUnscoped(user);
      scoped = scoped.filter(opp => {
        if (unscoped) return true;
        const rootId = getRootOppTypeId(opp?.opportunityType);
        if (!rootId) return true;
        return userAllowed.has(rootId);
      });
      if (selectedOppTypeId) {
        const tabScoped = scoped.filter(
          opp => Number(getRootOppTypeId(opp?.opportunityType)) === Number(selectedOppTypeId)
        );
        if (tabScoped.length > 0) scoped = tabScoped;
      }
    }

    // Use the canonical CRM type from the company (covers all CRMs incl. Tekion) and
    // pass crmLeadObj so prepareOpportunityList can fall back to the lead's CRM id
    // when an opportunity has none of its own.
    return prepareOpportunityList(scoped, user?.company?.crmIntegrationType, lead?.crmLeadObj);
  };
  const handleCheckbox = e => {
    setIsAppoinmentCofirm(e.target.checked);
    e.target.checked && hadnleAppointmentDialog();
  };

  const handleAppointmentForm = () => {
    let appointmentStatus = "";
    let confirmedBy = "";

    if (appointment?.isConfirmed) {
      appointmentStatus = "confirmed";
    } else {
      appointmentStatus = appointment?.appointmentStatus.toLowerCase();
    }

    if (appointment?.isLastActionByLead) {
      confirmedBy = appointment?.lead?.fullName;
    } else {
      if (appointment?.updatedBy?.fullName) {
        confirmedBy = appointment?.updatedBy?.fullName;
      } else {
        confirmedBy = appointment?.createdBy?.fullName;
      }
    }
    // Mon, June 6th 2022, 8:35:20 AM: Rescheduled by <Lead Name>
    const lastTimeStamp = convertUtcToLocal(
      appointment?.dateUpdated,
      "ddd, MMMM Do YYYY, h:mm:ss A"
    );
    return confirmedBy
      ? `${lastTimeStamp}: ${
          appointmentStatus[0]?.toUpperCase() + appointmentStatus.slice(1, appointmentStatus.length)
        } by ${confirmedBy || ""}`
      : "";
  };
  const allowEdit = () => {
    return sessionStorage?.getItem("currentLocationId")?.includes(",");
  };

  useEffect(() => {
    if (user && user?.locations?.length > 0) {
      const locationIDs = user?.locations.map(location => location?.location?.id);
      setUserLocationsId(locationIDs);
    }
  }, [user]);
  useEffect(() => {
    if (
      !isUndefined(appointment?.id) &&
      appointment?.appointmentStatus !== "CANCELLED" &&
      appointment?.appointmentStatus !== "NO_SHOWED" &&
      appointment?.appointmentStatus !== "SHOWED" &&
      dayjs.utc(appointment?.startDatetime).isBefore(dayjs.utc())
    ) {
      setStatusDropdownList([
        ...statusDropdownList,
        { key: "SHOWED", value: "SHOWED", label: "Showed" },
        { key: "NO_SHOWED", value: "NO_SHOWED", label: "No Show" },
      ]);
    }
  }, [appointment]);

  const handleStatusUpdateLabel = e => {
    setDropdownStatus(e);
  };

  const handleOpportunityIdDialog = oppr => {
    // oppr may be an opportunity OR a lead (with leadOpportunities) — normalize to the opportunity.
    const opportunity = oppr?.leadOpportunities?.length ? oppr.leadOpportunities[0] : oppr;
    const { label, fullLabel, crmLink, opportunityId, isOpportunity, hasCrmId } = getOpprDetails({
      opportunity,
      crmLeadObj: leadInfo?.crmLeadObj,
      selectedLead: leadInfo,
    });

    // No real CRM id → plain EAI label (or lead name when there's no opportunity)
    if (!hasCrmId) {
      return (
        <div className="flex flex-col justify-start items-baseline h-[20px]">
          <div> {!oppr?.id && <p className="mb-0">Lead: {leadInfo?.leadFullname}</p>}</div>
          <div>
            {oppr?.id && (
              <Tooltip title={fullLabel}>
                <p>{label}</p>
              </Tooltip>
            )}
          </div>
        </div>
      );
    }

    const opprName = isOpportunity ? oppr?.name : `Lead: ${leadInfo?.leadFullname}`;
    const hasPermission =
      userLocationsId?.length > 0 && userLocationsId.includes(leadInfo?.location?.id);

    return hasPermission ? (
      <div
        className="flex flex-col justify-start items-baseline h-[40px] cursor-pointer"
        onClick={() =>
          handleOpportunityWarningDialog(oppr, crmLink, opportunityId, opprName, isOpportunity)
        }
      >
        <Tooltip title={fullLabel}>
          <p className="flex secondaryColorTheme flex-col justify-start items-baseline h-[40px] cursor-pointer">
            {label}
          </p>
        </Tooltip>
      </div>
    ) : (
      <div
        className="flex flex-col justify-start items-baseline h-[20px]"
        onClick={() => {
          message.error(
            `${lang.donthavePermission} ${isOpportunity ? "opportunity" : "lead"} in the ${
              leadInfo?.location?.title
            }`
          );
        }}
      >
        <Tooltip title={fullLabel}>
          <p>{label}</p>
        </Tooltip>
      </div>
    );
  };

  const handleOpportunityId = oppr => {
    try {
      // oppr may be an opportunity OR a lead (with leadOpportunities) — normalize to the opportunity.
      const opportunity = oppr?.leadOpportunities?.length ? oppr.leadOpportunities[0] : oppr;
      const { label, fullLabel, crmLink, isOpportunity, hasCrmId } = getOpprDetails({
        opportunity,
        crmLeadObj: leadInfo?.crmLeadObj,
        selectedLead: leadInfo,
      });

      // No real CRM id → plain EAI label (or lead name when there's no opportunity)
      if (!hasCrmId || !crmLink) {
        return (
          <div className="flex flex-col justify-start items-baseline h-[20px]">
            <div> {!oppr?.id && <p className="mb-0">Lead: {leadInfo?.leadFullname}</p>}</div>
            <div>
              {oppr?.id && (
                <Tooltip title={fullLabel}>
                  <p>{label}</p>
                </Tooltip>
              )}
            </div>
          </div>
        );
      }

      const hasPermission =
        userLocationsId?.length > 0 && userLocationsId.includes(leadInfo?.location?.id);

      return (
        <Tooltip title={fullLabel}>
          <RedirectIcon
            className="cursor-pointer"
            onClick={() =>
              hasPermission
                ? window.open(crmLink)
                : message.error(
                    `You do not have permissions to view ${
                      isOpportunity ? "opportunity" : "lead"
                    } in the ${leadInfo?.location?.title}`
                  )
            }
          />
        </Tooltip>
      );
    } catch (err) {
      console.log(err);
    }
  };
  // Always offer the appointment's current "active" status (Scheduled / Rescheduled /
  // Confirmed) as an option, so the user can revert an unsaved selection back to it.
  // These aren't terminal transitions, so the base tags list never includes them.
  const ACTIVE_APPOINTMENT_STATUS_LABELS = {
    SCHEDULED: "Scheduled",
    RESCHEDULED: "Rescheduled",
  };
  const tags = [
    ...(ACTIVE_APPOINTMENT_STATUS_LABELS[appointment?.appointmentStatus]
      ? [
          {
            title: ACTIVE_APPOINTMENT_STATUS_LABELS[appointment.appointmentStatus],
            value: appointment.appointmentStatus,
            style: {
              backgroundColor: "#3B82F6",
              color: "white",
            },
          },
        ]
      : []),
    ...(appointment?.appointmentStatus !== "SHOWED" &&
    appointment?.appointmentStatus !== "NO_SHOWED"
      ? [
          {
            title: "Cancelled",
            value: "CANCELLED",
            style: {
              backgroundColor: "#F43F5E",
              color: "white",
            },
          },
        ]
      : []),
    ...(dayjs.utc(appointment?.startDatetime).isBefore(dayjs.utc())
      ? [
          {
            title: "Showed",
            value: "SHOWED",
            style: {
              backgroundColor: "#22C55E",
              color: "white",
            },
          },
          {
            title: "No Showed",
            value: "NO_SHOWED",
            style: {
              backgroundColor: "#334155",
              color: "white",
            },
          },
        ]
      : appointment.appointmentStatus === "SHOWED"
      ? [
          {
            title: "Showed",
            value: "SHOWED",
            style: {
              backgroundColor: "#22C55E",
              color: "white",
            },
          },
        ]
      : appointment.appointmentStatus === "NO_SHOWED"
      ? [
          {
            title: "No Showed",
            value: "NO_SHOWED",
            style: {
              backgroundColor: "#334155",
              color: "white",
            },
          },
        ]
      : []),
  ];

  const opporlist =
    whileCreateNewOppr?.length > 0 ? whileCreateNewOppr : handleLeadOpportunityList();
  return (
    <>
      {error && (
        <div className="w-full mb-4">
          <CustomAlert message={error} type="error" className="p-2" showIcon />
        </div>
      )}
      <div className="bg-[#f1f5f9] p-4 rounded-[8px] flex flex-col gap-3">
        <div className="flex flex-row items-center justify-start gap-6">
          <div className="w-[35%] flex flex-col gap-2">
            <span className="text-sm">{lang.appointmentFor}</span>

            {!isEmpty(lead) ? (
              <div className="flex flex-row items-center gap-1">
                <Tooltip title={appointment?.lead?.fullName || lead?.fullName}>
                  <span
                    className="my-1 font-medium secondaryColorTheme cursor-pointer line-clamp-1"
                    onClick={() => {
                      const leadId = appointment?.lead?.id || lead?.id;
                      if (leadId) {
                        redirectToLead(leadId);
                      }
                    }}
                  >
                    {appointment?.lead?.fullName || lead?.fullName}
                  </span>
                </Tooltip>
                {allowLeadChange && showLeadChanger && isUndefined(appointment?.id) && (
                  <CloseCircleFilled className="cursor-pointer" onClick={() => setlead(null)} />
                )}
              </div>
            ) : (
              <Select
                placeholder={lang.selectLead}
                showSearch
                onSearch={value => setTimeout(() => setleadSearch(value), 200)}
                loading={leadsLoader}
                className="w-full"
                onSelect={value => {
                  const lead = leadList.find(lead => +lead.id === +value);
                  setlead(lead);
                  setLeadOpportunity(lead?.crmLeadObj?.activeLeadOpportunity?.id);
                }}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {(leadList || []).map((item, index) => (
                  <Select.Option key={index} value={item.id}>
                    {item.fullName}
                  </Select.Option>
                ))}
              </Select>
            )}
          </div>
          <div className="flex flex-col gap-2 mt-[-8px]">
            <span className="text-sm">Created By</span>
            <span className="text-sm font-[600]">
              {/* When the appointment was created by the lead (extraData
                  created_by_user_type === "LEAD"), show the lead's name;
                  otherwise fall back to the creating user's name. */}
              {appointment?.extraData?.created_by_user_type === CREATED_BY_USER_TYPE_LEAD
                ? `${appointment?.lead?.fullName || lead?.fullName} (Lead)`
                : appointment?.createdBy?.fullName || user.fullName}
            </span>
          </div>
          <div className="ml-auto">
            {leadInfo?.crmLeadObj?.activeLeadOpportunity &&
              (localStorage.getItem("isOpporDialogFlagChangedLocal")
                ? handleOpportunityId(leadInfo?.crmLeadObj?.activeLeadOpportunity)
                : !handleOpportunityDilaog(user?.locations, user)
                ? handleOpportunityId(lead)
                : handleOpportunityIdDialog(leadInfo?.crmLeadObj?.activeLeadOpportunity))}
          </div>
        </div>
        <div className="flex flex-row items-center justify-start gap-6">
          <div className="flex w-[35%] flex-col gap-2">
            <span className="text-sm">Location</span>
            <span className="text-sm font-[600]">{getLocationObj(user)?.location?.title}</span>
          </div>
          {!isUndefined(appointment?.id) && (
            <div className="flex flex-col gap-2">
              <span className="text-sm flex items-center gap-2">
                Status{" "}
                <UndoOutlined
                  className="cursor-pointer"
                  onClick={() => {
                    setDropdownStatus(() => {
                      if (lead?.activeAppointment?.appointmentStatus && isFromCard) {
                        return lead?.activeAppointment?.appointmentStatus;
                      }
                      if (appointment?.appointmentStatus) {
                        return appointment?.appointmentStatus;
                      }
                    });
                    setstatusEditMode(false);
                  }}
                />
              </span>
              {statusEditMode ? (
                <Select
                  disabled={disabledControl() || allowEdit()}
                  size="small"
                  value={dropdownStatus}
                  className="w-[150px]"
                  onSelect={value => {
                    setisFormChanged(true);
                    handleStatusUpdateLabel(value);
                    setstatusEditMode(false);
                  }}
                >
                  {tags.map((item, index) => (
                    <Select.Option value={item.value} key={index}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <div className="flex flex-row items-center gap-1">
                  <span className="text-xs font-[600] text-grey-700 underline decoration-dotted">
                    {dropdownStatus}{" "}
                  </span>
                  <EditFilled
                    style={{
                      color: disabledControl() || allowEdit() ? "grey" : "black",
                    }}
                    className={`${
                      disabledControl() || allowEdit() ? "cursor-not-allowed" : "cursor-pointer"
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      if (disabledControl() || allowEdit()) return;
                      setstatusEditMode(true);
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {!isEmpty(lead) && (
        <>
          <div className="w-full flex gap-2 my-1 items-center">
            <p className="font-normal">
              {lang.leadOpportunities} <span className="text-red-500">*</span>
            </p>
            {/* <p className="font-normal"></p> */}
          </div>
          <div className="w-full flex items-start gap-2" id="antdOpprDropdown">
            <Select
              className="flex-1 w-3/4 lg:w-full"
              value={String(leadOpportunity)}
              placeholder={lang.selectOpportunity}
              onChange={value => {
                setisFormChanged(true);
                setLeadOpportunity(value);
              }}
              // getPopupContainer={() => document.getElementById("antdOpprDropdown")}
              disabled={
                appointment?.id ||
                isEmpty(leadOpportunities) ||
                // leadOpportunity is a scalar id — lodash isEmpty() returns true for numbers,
                // so use an explicit null/empty-string check instead.
                leadOpportunity === null ||
                leadOpportunity === undefined ||
                leadOpportunity === "" ||
                disabledControl() ||
                allowEdit()
              }
            >
              {(opporlist || []).map(opportunity => (
                <Select.Option key={opportunity?.id} value={opportunity?.id}>
                  {getOpportunityDisplayName(opportunity)}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="w-full grid grid-cols-3 gap-1 mt-1">
            <div>
              <div className="flex-1" id="antdDateDropdown">
                <p className="font-normal">
                  {lang.appointmentDate} <span className="requireFieldStar">*</span>
                </p>
                <DatePicker
                  format="MM/DD/YYYY"
                  getPopupContainer={() => document.getElementById("antdDateDropdown")}
                  value={dayjs.utc(appointmentDate).tz(appointment?.timezone || dayjs.tz.guess())}
                  placeholder={lang.selectDate}
                  onChange={onChange}
                  className="w-full"
                  disabledDate={current => {
                    return (
                      dayjs()
                        .tz(appointment?.timezone || dayjs.tz.guess())
                        .add(-1, "days") >= current || disableWeekDay(current)
                    );
                  }}
                  disabled={disabledControl() || allowEdit()}
                />
              </div>
            </div>
            <div>
              {" "}
              <div className="flex-1" id="antdTimeDropdown">
                <p className="font-normal">
                  {lang.appointmentTime} <span className="requireFieldStar">*</span>
                </p>
                <CustomTimePicker
                  fkey="appointment_time"
                  value={appointmentTime}
                  startTime={workingTime && workingTime[0]}
                  endTime={workingTime && workingTime[1]}
                  onChange={e => onTimeChange(e)}
                  placeholder={lang.selectTime}
                  getPopupContainer={() => document.getElementById("antdTimeDropdown")}
                  disabledTimes={disabledHours}
                  disabled={disabledControl() || allowEdit() || workHoursLoading}
                  defaultDate={appointmentDate}
                  showTentative={showTentativeOption}
                />
              </div>
            </div>
            <div>
              {" "}
              <div className="w-full" id="antdTimezoneDropdown">
                <p className="font-normal">
                  {lang.timezone} <span className="requireFieldStar">*</span>{" "}
                  <Tooltip
                    placement="topLeft"
                    title={
                      sessionStorage?.getItem("currentLocationId")?.includes(",")
                        ? "This is sales person’s timezone."
                        : "This is the selected location’s timezone, not the sales person’s timezone."
                    }
                  >
                    <span>
                      <AntdIconV4
                        type="QuestionCircleOutlined"
                        className="text-gray-500 ml-[5px]"
                      />
                    </span>
                  </Tooltip>
                </p>
                {/* <Select
                  className="w-full"
                  value={timezone}
                  getPopupContainer={() => document.getElementById("antdTimezoneDropdown")}
                  placeholder={lang.selectTimezone}
                  onChange={value => {
                    setisFormChanged(true);
                    setTimezone(value);
                  }}
                  disabled={disabledControl() || allowEdit()}
                >
                  {timezones.map(timezone => (
                    <Select.Option key={timezone.value} value={timezone.value}>
                      {timezone.label}
                    </Select.Option>
                  ))}
                </Select> */}
                <TimezoneSelect
                  placeholder={lang.selectTimezone}
                  value={timezone}
                  disabled={disabledControl() || allowEdit()}
                  groupByRegion
                  showPopularFirst
                  autoDetect
                  dropdownAlign="right"
                  dropdownWidth={230}
                  onChange={value => {
                    setisFormChanged(true);
                    setTimezone(value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-1" id="antdAssignedDropdown">
            <p className="font-normal">
              {lang.assignedTo} <span className="requireFieldStar">*</span>
            </p>
            <UserSelector
              placeholder="Select Assigned User"
              handleUsersSelection={value => {
                setisFormChanged(true);
                setAssignedUserId(value);
              }}
              value={+assignedUserId}
              multiple={false}
              showAll={false}
              item={{
                item: {
                  user: assignedUserData || appointment?.user || appointment?.createdBy || user,
                },
              }}
              ignoreCache
              extraQueryParams={{
                isAllLocationUsers: true,
              }}
            />
          </div>

          <div className="mt-1">
            <p className="font-normal">
              {lang.title} <span className="requireFieldStar">*</span>
            </p>
            <Input
              placeholder={lang.appointmentTitle}
              name="title"
              value={title}
              onChange={e => {
                setisFormChanged(true);
                setTitle(e.target.value);
              }}
              disabled={disabledControl() || allowEdit()}
            />
          </div>
          <div className="mt-1">
            <p className="font-normal">{lang.description}</p>
            <TextArea
              rows={2}
              placeholder={lang.descriptionPlaceholder}
              name="note"
              value={note}
              onChange={e => {
                setisFormChanged(true);
                setNote(e.target.value);
              }}
              disabled={disabledControl() || allowEdit()}
            />
          </div>

          {vehiclesOfInterests.length > 0 && (
            <div className="mt-1" id="antdVOIDropdown">
              <p className="font-normal">{lang.vehicleOfInterest}</p>
              <Select
                className="w-full"
                value={String(vehicle)}
                placeholder={lang.selectVehicle}
                getPopupContainer={() => document.getElementById("antdVOIDropdown")}
                onChange={value => {
                  setisFormChanged(true);
                  setVehicle(value);
                }}
                disabled={disabledControl() || allowEdit()}
              >
                {vehiclesOfInterests?.map(el => {
                  let voi = "";
                  if (el?.year && +el.year !== 0) voi = `${voi}${el.year} `;
                  if (el?.make && el.make !== "0") voi = `${voi}${el.make} `;
                  if (el?.model && el.model !== "0") voi = `${voi}${el.model} `;
                  return voi !== "" && +voi !== 0 ? (
                    <Select.Option key={el?.id} value={String(el?.id)}>
                      {voi}
                    </Select.Option>
                  ) : (
                    <Select.Option key={el?.id} value={String(el?.id)}>
                      {el?.customerInterest === VEHICLE_INTERESTS_TYPE.BUY
                        ? "No vehicles of interest"
                        : el?.customerInterest === VEHICLE_INTERESTS_TYPE.SELL
                        ? "No vehicles for sell"
                        : el?.customerInterest === VEHICLE_INTERESTS_TYPE.TRADE
                        ? "No vehicles for trade"
                        : "No vehicles"}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          )}

          <div className="mt-1">
            <CustomCheckbox
              checkboxLabel={
                <strong className={`text-[${disabledControl() ? "" : "blue"}]`}>
                  {lang.confirm}
                </strong>
              }
              checked={isAppoinmentConfirm}
              disabled={
                disabledControl() ||
                (appointment?.id && isChangedByUser && isAppoinmentConfirm) ||
                !canSchedule ||
                (!canReSchedule && appointment) ||
                allowEdit()
              }
              handleChange={e => {
                setisFormChanged(true);
                handleCheckbox(e);
              }}
            />

            {!isUndefined(appointment?.id) && <p className="mt-[2px]">{handleAppointmentForm()}</p>}
            {!isUndefined(appointment?.id) &&
              (appointment?.dateCreated || appointment?.dateUpdated) && (
                <div className="mt-1 text-xs text-grey-700 flex flex-col gap-0.5">
                  {appointment?.dateCreated && (
                    <span>
                      Created:{" "}
                      <span className="font-medium">
                        {convertUtcToLocal(
                          appointment?.dateCreated,
                          DATE_TIME_FORMATS.DD_MMM_YYYY_hh_mm_A,
                          appointment?.timezone
                        )}
                      </span>
                    </span>
                  )}
                  {appointment?.dateUpdated && (
                    <span>
                      Updated:{" "}
                      <span className="font-medium">
                        {convertUtcToLocal(
                          appointment?.dateUpdated,
                          DATE_TIME_FORMATS.DD_MMM_YYYY_hh_mm_A,
                          appointment?.timezone
                        )}
                      </span>
                    </span>
                  )}
                </div>
              )}
          </div>
        </>
      )}
      <div className="bg-[#faf8fc] mt-3 p-4 flex flex-col gap-3">
        <div className="w-full flex items-center justify-end">
          <FooterComponent
            lang={lang}
            appointment={appointment}
            setVisible={() => {
              setAppointmentModelVisible(false, false);
              onClose();
            }}
            saveAppointment={handleSaveAppointment}
            deleteAppointment={handleDeleteAppointment}
            loading={loading || updateLoading}
            deleteLoading={deleteLoading}
            canSchedule={canSchedule}
            canReSchedule={canReSchedule}
            canCancel={canCancel}
            isAppoinmentConfirm={isAppoinmentConfirm}
            isFormChanged={isFormChanged}
            allowEdit={allowEdit}
            isChangedByUser={isChangedByUser}
            hadnleAppointmentDialog={hadnleAppointmentDialog}
            disabledControl={disabledControl}
            dropdownStatus={dropdownStatus}
            onClose={onClose}
          />
        </div>
      </div>
    </>
  );
};
export default AppointmentForm;

const FooterComponent = ({
  appointment = null,
  setVisible,
  saveAppointment,
  deleteAppointment,
  loading = false,
  deleteLoading = false,
  canSchedule,
  canReSchedule,
  canCancel,
  isAppoinmentConfirm,
  allowEdit,
  isChangedByUser,
  hadnleAppointmentDialog,
  disabledControl,
  dropdownStatus,
  onClose,
  lang,
  isFormChanged,
}) => {
  const [status, setStatus] = useState(undefined);
  const handleStatusUpdate = e => {
    saveAppointment({ status: e });
  };

  const handleAppointmentStatus = e => {
    if (dropdownStatus === "CANCELLED") {
      if (
        !isUndefined(appointment?.id) &&
        appointment?.appointmentStatus !== "CANCELLED" &&
        appointment?.appointmentStatus !== "NO_SHOWED" &&
        appointment?.appointmentStatus !== "SHOWED" &&
        dayjs(dayjs(appointment?.startDatetime).utc().local().format("MM/DD/YYYY")).isAfter(
          dayjs().utc().local().format("MM/DD/YYYY")
        )
      ) {
        deleteAppointment(e);
        return;
      } else {
        saveAppointment({ status: dropdownStatus });
        return;
      }
    } else if (dropdownStatus === "SHOWED" || dropdownStatus === "NO_SHOWED") {
      saveAppointment({ status: dropdownStatus });
      return;
    }

    saveAppointment(e);
  };

  const buttons = [
    <CustomButton
      key="back"
      handleClick={() => {
        setVisible(false);
        onClose();
      }}
      className="ml-2"
      btnText={lang.close}
    />,
  ];

  if (
    appointment?.appointmentStatus !== "CANCELLED" &&
    appointment?.appointmentStatus !== "NO_SHOWED" &&
    appointment?.appointmentStatus !== "SHOWED"
  ) {
    buttons.unshift(
      <CustomButton
        key="submit"
        type="primary"
        handleClick={handleAppointmentStatus}
        loading={loading || deleteLoading}
        disabled={!canSchedule || (!canReSchedule && appointment) || allowEdit() || !isFormChanged}
        btnText="Save"
      />
    );
  }

  return buttons;
};
